'use strict';exports.__esModule = true;var _RealtorLanding = require('../../../static/images/RealtorLanding');var _RealtorLanding2 = _interopRequireDefault(_RealtorLanding);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var CONSTANTS_COMMENTS = [
{
    photo: _RealtorLanding2.default.photoUser1,
    flag: _RealtorLanding2.default.flagJapan,
    region: 'commentJapan' },

{
    photo: _RealtorLanding2.default.photoUser,
    flag: _RealtorLanding2.default.flagAmerica,
    region: 'commentAmerica' },

{
    photo: _RealtorLanding2.default.photoUser2,
    flag: _RealtorLanding2.default.flagGermany,
    region: 'commentGermany' }];exports.default =



CONSTANTS_COMMENTS;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TabSellingProperties/Constants.js
// module id = 2868
// module chunks = 0